export default {
  feedback: {
    token_required: 'Por favor, clique na caixa de verificação para confirmar que é humano',
    frequent_requests:
      'Por favor, verifique o seu SMS. Já enviámos o código para o número indicado por SMS. Caso não tenha recebido, verifique o número de telefone ou tente novamente em 10 minutos.',
  },
};
